<!-- Quiz Start Page -->
<section *ngIf="!quizStart">
    <app-start-page (quizStart)="startQuiz($event)" [moduleNumber]="moduleNumber"></app-start-page>
</section>

<!-- Quiz Content -->
<section *ngIf="!showResults && quizStart">

    <!-- Page Title -->
    <div class="title text-center content-box-header">
        <h2 class="container title">Module {{moduleNumber}} - Quiz</h2>
        <h2 class="container sub-title" *ngIf="questions.length <= questionsLimit">Questions: {{questions.length}}</h2>
        <h2 class="container sub-title" *ngIf="questions.length > questionsLimit">Questions: {{questionsLimit}}</h2>
    </div>

    <div *ngIf="cheatQuiz" class="mt-4 text-center"><button type="button" (click)="cheatQuiz_click()">Cheat Quiz</button></div>

    <!-- Create Question Forms -->
    <div *ngFor="let question of questions | slice:0:questionsLimit; let i = index;">
        <app-question-form [question]="question" [answer]="answers[i]" (onChoiceMade)="updateChoice($event, i)" [questionNumber]="i"></app-question-form>
    </div>

    <!-- Submit Quiz -->
    <button type="button" class="btn waves-dark" (click)="submitQuiz()">Submit<i class="fas fa-angle-right ml-3"></i></button>
</section>

<!-- Results -->
<section *ngIf="showResults && quizStart">
    <app-feedback-page [questions]="questions" [answers]="answers" [correctAnswers]="correctAnswers" [percentage]="percent" [moduleNumber]="moduleNumber"></app-feedback-page>

    <!-- Passed Quiz -->
    <button type="button" class="btn waves-dark" (click)="handleQuiz()" *ngIf="status">
        Continue<i class="fas fa-angle-right ml-3"></i></button>

    <!-- Failed Quiz -->
    <div class="retake-buttons" *ngIf="!status">

        <!-- Back to Content -->
        <button type="button" class="btn waves-dark" (click)="returnToModule()"> <i class="fas fa-angle-left" ></i>
                Review</button>

        <!-- Retake Quiz -->
        <button type="button" class="btn waves-dark" (click)="retakeQuiz()"> <i class="fas fa-angle-left"></i>
                    Retake</button>
    </div>
</section>
